import { DataFormatoPT } from "app/types/DataFormatoPT"
const estilos = require('./disponibilidade-capacidade-de-carga.module.scss').default
import React, { useEffect, useState } from "react"
import Calendar from "react-calendar"
import { format, isToday } from "date-fns"
import Legenda from "app/components/itens-orcamento/legenda/Legenda"
import globalMU from "globalMU"
import clsx from "clsx"
import { InputMascara } from "app/components/inputs/InputMascara"
import { DadosPorItem } from "./DadosPorItem"
import { traduzirSituacao } from "./traduzirSituacao"
import { Dict } from "app/utils/Dict"
import { ChaveAgrupamento } from "./ChaveAgrupamento"
import { IdentificadorItem } from "app/types/IdentificadorItem"
import { LegendaDisponibilidadeCapacidadeDeCarga } from "./LegendaDisponibilidadeCapacidadeDeCarga"
const estiloBotoes = require('../../../estilos/botoes.module.scss').default
const estiloFormulario = require('../../../estilos/formulario.module.scss').default

export type DisponibilidadeCapacidadeCargaItemOrcamentoProps = {
    dadosPorItem: DadosPorItem
    
    novaDataPrevista: DataFormatoPT
    onNovaDataSelecionada: (novaData:DataFormatoPT) => void
    onAtualizarCalendario: (dataReferencia:Date) => void
}

export const DisponibilidadeCapacidadeCargaItemOrcamento = (props:DisponibilidadeCapacidadeCargaItemOrcamentoProps) => {
    const [novaDataPrevista, setNovaDataPrevista]  = useState<DataFormatoPT>(props.novaDataPrevista ?? "")
    
    const calendario = <div className="_mt-8 _mb-8 _max-w-md"
        id="DisponibilidadeCapacidadeCargaPorItemOrcamento_calendario"
    >
        <Calendar 
            locale="pt-BR"
            showNeighboringMonth={false}
            tileClassName={({date,view}) => {
                const dataNoFormatoPT = globalMU.converterDataFormatoENParaPT(format(date, "yyyy-MM-dd"))
                const situacao = props.dadosPorItem.datas.find(d => d.data == dataNoFormatoPT)?.situacao

                const classeParaSituacao =  
                        situacao == null ? null :
                        situacao == "DISPONIVEL" ? estilos.dataDisponivel :
                        situacao == "INDISPONIVEL" ? estilos.dataIndisponivel : 
                        situacao == "SEM_CADASTRO" ? estilos.dataSemCadastro : null

                // Duas marcas por cima da cor de situação: o dia de hoje (referência de "a partir
                // de quando dá") e a data que está no campo "Nova Data" — que muda tanto ao clicar
                // no calendário quanto ao digitar no campo, por isso a comparação é com o ESTADO
                // `novaDataPrevista`, não com o dia clicado.
                return ['no-global-button',
                        classeParaSituacao,
                        isToday(date) ? estilos.dataHoje : null,
                        dataNoFormatoPT == novaDataPrevista ? estilos.dataSelecionada : null]
            }}
            onClickDay={date => {
                const novaDataPrevista_ = format(date, "dd/MM/yyyy")
                setNovaDataPrevista(novaDataPrevista_)
                props.onNovaDataSelecionada(novaDataPrevista_)
            }}
           
            onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
                props.onAtualizarCalendario(activeStartDate)
            }}
            />
    </div>



    const novaDataPrevistaInput = <div className={estiloFormulario.formulario}>
        <label>Nova Data </label>
        <InputMascara
            id="DisponibilidadeCapacidadeCargaPorItemOrcamento_novaDataPrevista"
            valor={novaDataPrevista}
            mascara="99/99/9999"
            onValorModificado={setNovaDataPrevista}

        />
    </div>

    const motivo = <div className="_font-bold _h-4 _w-full"
            id="DisponibilidadeCapacidadeCargaPorItemOrcamento_motivo"
    >
        {traduzirSituacao(props.dadosPorItem.situacao)}
    </div>


    return <>
        <div className={estilos.container}
            id="DisponibilidadeCapacidadeCargaPorItemOrcamento_calenario">
            <div className={estilos.containerTitulo} >
                <span className={estilos.titulo}>
                    Consulta Disponibilidade Capacidade de Carga - {props.dadosPorItem.descricao}
                </span>
            </div>

            <div className={estilos.conteudo}>
                {motivo}

                {calendario}

                {novaDataPrevistaInput}

                <LegendaDisponibilidadeCapacidadeDeCarga/>
            </div>
        </div>
    </>
}